import {
  cn,
  NumericInput,
  type NumericInputProps,
  Select,
  SelectItem,
  type SelectProps,
} from "@kyan/ui";

export interface NumericInputWithSelectProps<SelectValueType extends string> {
  inputProps: Omit<NumericInputProps, "variant">;
  selectProps?: Omit<SelectProps<SelectValueType>, "children"> & {
    items?: SelectValueType[];
    itemClassName?: string;
  };
}

export const NumericInputWithSelect = <T extends string>({
  inputProps: { wrapperClassName, ...restInputProps },
  selectProps: {
    triggerClassName,
    iconClassName,
    items,
    itemClassName,
    ...restSelectProps
  } = {},
}: NumericInputWithSelectProps<T>) => {
  const shouldShowSelect = Number(items?.length) > 0;

  return (
    <NumericInput
      variant="secondary"
      wrapperClassName={cn({ "pr-0": shouldShowSelect }, wrapperClassName)}
      rightSlot={
        shouldShowSelect ? (
          <Select
            tabIndex={-1}
            variant="builtin"
            iconClassName={cn("right-1 text-[8px]", iconClassName)}
            triggerClassName={cn(
              "border-l-divider w-14 rounded-l-none",
              triggerClassName,
            )}
            {...restSelectProps}
          >
            {items?.map((item) => (
              <SelectItem
                showCheck
                key={item}
                value={item}
                className={itemClassName}
              >
                {item}
              </SelectItem>
            ))}
          </Select>
        ) : null
      }
      {...restInputProps}
    />
  );
};
